import type { FaireProductEntity } from "../../entity_types/product";

export const p_mxm5njk9bj: FaireProductEntity = {
  token: "p_mxm5njk9bj",
  type: "product",
  name: "Thank You Woodland Floral  Plantable Seed Paper Card",
  brandToken: "b_467z7rvjdf",
  brandName: "Erika's Whimsical Art",
  imageUrl:
    "https://cdn.faire.com/fastly/869e948038d6a9437061f1df425f14a32f66bb931b0114540ce19e697d0b5235.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d6e8c57a5c19bc99f4d90d055756f9e98557b989c54fe33a00d0240bd586c854.jpeg",
    "https://cdn.faire.com/fastly/3f3667f80e650c21cb0b0e25179eef9213548af8350ccc53efdc21fe010ecd03.jpeg",
    "https://cdn.faire.com/fastly/b367496ae556dad8d8b62525075f356ff3e2b7ffe0046318234f79bbdfa2e0e9.jpeg",
    "https://cdn.faire.com/fastly/200fdffeb3aa0a33dd2e27b7ba0e959c375320299df26eddce29acb795d49bbc.jpeg",
    "https://cdn.faire.com/fastly/400f9ca1fb8fde5a0cc8c8994b378211974c726669401bf99c62844aad21305f.jpeg",
    "https://cdn.faire.com/fastly/8a3e0a1c5861de637d90a19652d607cdb38d1bea841ddb1ad1882ba12ae2fe99.jpeg",
    "https://cdn.faire.com/fastly/d6d693e0fd2875ee9841316799a0ade4e94bad5bc599a9e3786bb4ed19401a73.jpeg",
    "https://cdn.faire.com/fastly/43dbe7154e4e6879dcd4f4b3a86d087fca155e47886a954215ca517002e0bab2.jpeg",
    "https://cdn.faire.com/fastly/328cd20b32bce2430274bc89067678a5288774eeb69f3b8807da322658c588f4.jpeg",
    "https://cdn.faire.com/fastly/b0e4458c18a0e37730337e57bc72b80d8ddb1722ff889bd9b76a33df8dd8e9ce.jpeg",
    "https://cdn.faire.com/fastly/66b6615d9cf12b3d17fb1f2f7ce0227c4226b5436e758739525d6aedaff5aaa7.jpeg",
    "https://cdn.faire.com/fastly/ec1c68ca7b8a33bbb6667b1ac908670a0de6752af2dfcfb64d4e4ce535920f65.jpeg",
    "https://cdn.faire.com/fastly/035d3110b6f1e57a6daf83b16dbcc292183971c5b9a42555b8fb38be1b2b9c35.jpeg",
    "https://cdn.faire.com/fastly/611fe3a7a4264eab335ef5e6225e6f152d6805b5cc80790ef1ccbd66d3e0a485.jpeg",
  ],
  priceDollars: 2.52,
  description:
    "Plantable Seed Paper Birthday Card, Blank Inside, Flower Illustration\n\nThe greeting card that keeps on giving. These blooming marvellous Eco-friendly cards are plantable and transform into beautiful flowers. Our seed paper is tree-free! Made of 100% Pre-Consumer Recycled Cotton that degrades naturally in the soil. Simple planting instructions are printed on the back of the card.\n\n• It is a thick recycled paper (about 150 gsm) embedded with various flower seeds. Seeds include Sweet Alyssum, Poppy, Baby’s Breath & Rudbeckia. These are non-invasive species that are commonly found in garden shops and can be grown in pots and left outside for bees and other pollinators.\n• Printed using an Inkjet Printer.\n• Comes with an A6 size 100% recycled envelope in natural colour.",
  tags: [],
  msrpDollars: 5.04,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:31.312Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
